import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import ExpensesComp from './ExpensesComp'
 
function Expenses() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <ExpensesComp/>      
        </div>
    </div>
  )
}

export default Expenses